import type { LoadableType } from '@confluence/loadable';
import { LoadableBackground } from '@confluence/loadable';
import type { MessageDescriptor } from 'react-intl';

export const CommentWarningDialog: LoadableType<{
	isDelete?: boolean;
	customHeading?: MessageDescriptor;
	customContent?: MessageDescriptor;
	customActionLabel?: MessageDescriptor;
	onClose: () => void;
	onCloseComplete: () => void;
	onConfirm: () => void;
	onCancel?: () => void;
}> = LoadableBackground({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-CommentWarningDialog" */ './CommentWarningDialog.tsx'
			)
		).CommentWarningDialog,
});
